exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".review-main-card[data-v-9e156452]{border-top:1px solid #f9f9f9;padding-top:12px}.review-main-card[data-v-9e156452]:first-of-type{border-top:none}.book-review[data-v-9e156452]{padding:0 15px 20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9e156452","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/books/BookReview.vue
// module id = 349
// module chunks = 0